import PropTypes from 'prop-types'
import { ControlFlags } from '../../models/common/control-flags-enum'

/**
 * @readonly
 * @enum {string}
 */
export const ObjectEventControlFlags = {
    [ControlFlags.RESOLVE_EVENT]: ControlFlags.RESOLVE_EVENT,
    [ControlFlags.ACKNOWLEDGE_EVENT]: ControlFlags.ACKNOWLEDGE_EVENT
}

export const objectEventControlFlagPropType = PropTypes.oneOf(Object.values(ObjectEventControlFlags))
